module.exports = __webpack_public_path__ + "img/sell-dark.1ce7217.svg";